import { Option, Schema as S } from "effect";
import * as AsyncData from "foldkit/asyncData";

import { apiData } from "../../api/asyncData";
import { Entry } from "../../api/schemas/entries";
import { ProfileImageExists, RecordSummary } from "../../api/schemas/records";
import { Capture } from "../../core/captureMatch";
import * as Picker from "../../widgets/recordPicker";

/** How the person was resolved (R5); `name` renders the "matched by name" affordances. */
export const Selected = S.Struct({
	id: S.String,
	by: S.Literals(["url", "name", "search", "created"]),
});
export type Selected = typeof Selected.Type;

export const Action = S.Literals(["link", "create", "sync"]);
export type Action = typeof Action.Type;

export const Model = S.Struct({
	page: S.Literal("Capture"),
	/** `None` while the stash is unread or when it is unreadable (R4); `resolving` tells the two apart. */
	payload: S.Option(Capture),
	/** The stash read, the URL lookup, or the name search is in flight (KTD4). */
	resolving: S.Boolean,
	selected: S.Option(Selected),
	/** The `getRecord` response: the sole PATCH base (KTD6). */
	record: apiData(RecordSummary).schema,
	entries: apiData(S.Array(Entry)).schema,
	image: apiData(ProfileImageExists).schema,
	picker: Picker.Model,
	/** The write chain in flight: its control shows the spinner and every writer is disabled. */
	inFlight: S.Option(Action),
	/** R11: the fields the last Sync wrote. */
	synced: S.Option(S.Array(S.String)),
	/** R8: the photo failed after the fields were saved. */
	photoFailed: S.Boolean,
	/** KTD6: a Link/Create 409 switched the selection to the record already carrying the identity. */
	conflict: S.Boolean,
	/** #7: a Link/Sync 412 found the record changed since it was fetched; it was reloaded. */
	stale: S.Boolean,
	error: S.Option(S.String),
});
export type Model = typeof Model.Type;

export const initial: Model = {
	page: "Capture",
	payload: Option.none(),
	resolving: true,
	selected: Option.none(),
	record: AsyncData.Idle(),
	entries: AsyncData.Idle(),
	image: AsyncData.Idle(),
	picker: Picker.init,
	inFlight: Option.none(),
	synced: Option.none(),
	photoFailed: false,
	conflict: false,
	stale: false,
	error: Option.none(),
};
